<mat-card-content>
  <form [formGroup]="resetPasswordForm" (keydown.enter)="submitForm()">
    <ds-lib-input-password
      [placeholder]="'dsLibCommon.login.password' | translate"
      [errorMessage]="'dsLibCommon.login.requiredPassword' | translate"
      [formControlPassword]="newPasswordControl"
    ></ds-lib-input-password>
    <ds-lib-input-password
      [placeholder]="'dsLibCommon.login.confirmPassword' | translate"
      [errorMessage]="'dsLibCommon.login.requiredConfirmPassword' | translate"
      [formControlPassword]="confirmPasswordControl"
    ></ds-lib-input-password>
    <mat-error
      *ngIf="
        resetPasswordForm.errors?.noMatch &&
        !newPasswordControl.errors?.required &&
        !confirmPasswordControl.errors?.required
      "
    >
      {{ 'dsLibCommon.login.passwordNotMatch' | translate }}
    </mat-error>
  </form>
</mat-card-content>
<ds-lib-login-button
  [title]="'dsLibCommon.login.validateButton' | translate"
  [disabled]="resetPasswordForm.invalid"
  [showSpinner]="showSpinner"
  (loginClick)="switchSpinner(); submitForm()"
></ds-lib-login-button>
<a mat-button (click)="onbackLogin()">{{ 'dsLibCommon.login.backLogin' | translate }}</a>
